import { measuredUsingConfigFor as wrap } from 'Components/Worksheets/Core/Helpers/configHelpers';

//defines which balance is used for which masses.
const getMeasuredUsingConfig = (prefix: string) => {
  const balance = wrap(`${prefix}.Equipment.Balance`);
  return {
    [`${prefix}.TestPortions.TareMass`]: balance,
    [`${prefix}.TestPortions.TareAndInitiallyPreparedMass`]: balance,
    [`${prefix}.TestPortions.TareAndOvenDryMass`]: balance,
    [`${prefix}.TestPortions.TareAndSSDMassInAir`]: balance,
    [`${prefix}.TestPortions.SSDMassInWater`]: balance,
  };
};
export default getMeasuredUsingConfig;
